import React, {
  useState,
  useEffect,
  Fragment,
  useMemo,
  useContext,
} from "react";
import api from "../../api/axios";
import "../Scss/ContactStyles.scss?v=1.1.3";

import {
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControl,
  Autocomplete,
  Alert,
  Button,
  ButtonGroup,
  CircularProgress,
  FormControlLabel,
  Switch,
  Fade,
  Divider,
  Typography,
  CardContent,
  Card,
  ListItem,
  ListItemText,
  List,
} from "@mui/material";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

//date
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import {
  CommonSubHeader,
  getOptionKey,
  isValidEmail,
  normalizeText,
  preguntasClave,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import ObservationsCards from "../../Components/ObservationsCards";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";
import {
  arrayToStatus,
  nuevoArrayDeNotas,
  notesHistoricLogic,
  showDuplicateContactsSwal,
  usarInformacionContacto,
  hasImportantChanges,
  hasNormalContactChanges,
  buscarDuplicados,
} from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";
import DuplicatedAlertList from "../../Components/helpers/ContactPlusClient/DuplicatedAlertList";
import ContactClientNotesComparisonDialog from "../../Components/ContactClientNotesComparisonDialog";
import { Dashboard, Save, TableChart, Visibility } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { PermissionContext } from "../../Components/Context/Context";
import Unauthorized from "../../Components/Common/Design/Unauthorized";

const contactStatus = [
  { nombre: "Pte Llamada", id: 0 },
  { nombre: "Llamado", id: 1 },
  { nombre: "Cliente", id: 2 },
  { nombre: "Cancelado", id: 3 },
];

const Editar = () => {
  const navigate = useNavigate();

  const { goView, goTable } = useLocationHelpers();
  const Swal = require("sweetalert2");
  // SAVE URL

  const [flagToClient, setFlagToClient] = useState(false);
  const [changeRender, setChangeRender] = useState(false);

  const [selectedCheckboxNotes, setSelectedCheckboxNotes] = useState("");

  const [openOptions, setOpenOptions] = useState({
    assignTo: false,
    lawyer: false,
    provinces: false,
    asociations: false,
    caseTypes: false,
    status: false,
    document_type: false,
  });

  const [options, setOptions] = useState({
    assignTo: [],
    lawyer: [],
    provinces: [],
    asociations: [],
    caseTypes: [],
    status: [],
    document_type: [],
  });

  // Loading Options
  const loadingOptions = Object.keys(openOptions).reduce((acc, key) => {
    acc[key] = openOptions[key] && options[key].length === 0;
    return acc;
  }, {});

  // TAKE VALUES
  const [searchParams] = useSearchParams();
  const contactId = searchParams.get("id");
  const getFlag = searchParams.get("flag");

  const [userLogged, setUserLogged] = useState(0);

  const [contactData, setContactData] = useState({
    company: { company_name: "Seleccionar", id: 0 },
    lawyer: { name: "Seleccionar", surname: "" },
    assignTo: { name: "Seleccionar", surname: "" },
    email: "",
    name: "",
    surname: "",
    address: "",
    province: { provincia: "Seleccionar", id_provincia: 0 },
    postalcode: "",
    nif: "",
    document_type: { name: "Seleccionar", id: 0 },
    phone: "",
    asociation: { asoc_name: "Seleccionar", id: 0 },
    case_type: { case_type: "Seleccionar", id: 0 },
    conditions: "",
    observations: "",
    status: { nombre: "Seleccionar", id: 0 },
    marketing: 0,
    date_in: "",
  });

  const [oldContactData, setOldContactData] = useState();

  const [dateInDefault, setDateInDefault] = useState();
  const [dateInFilter, setDateInFilter] = useState(0);

  const [multipleContacts, setMultipleContacts] = useState([]);
  const [multipleClients, setMultipleClients] = useState([]);
  const [associatedClient, setAssociatedClient] = useState([]);

  const [marketingToShow, setMarketingToShow] = useState(false);
  const [marketingToSend, setMarketingToSend] = useState(0);
  const [valCaseTypeForm, setValCaseTypeForm] = useState("");

  // OBSERVATIONS
  const [titleObservation, setTitleObservation] = useState("");
  const [statuses, setStatuses] = useState("");
  // OBSERVATIONS

  // FLAGS
  const [flag, setFlag] = useState(false);
  const [changeOptionsFlag, setChangeOptionsFlag] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [flagToReload, setFlagToReload] = useState(false);

  const [flagContactNoExistence, setFlagContactNoExistence] = useState(false);
  const [flagClientFounded, setFlagClientFounded] = useState(0);
  const [flagSameDocument, setFlagSameDocument] = useState(false);

  const [differentNotes, setDifferentNotes] = useState("");

  const { can } = useContext(PermissionContext);
  const [unauthorized, setUnauthorized] = useState(false);
  const [sameNifForbidden, setSameNifForbidden] = useState(false);

  const getDataList = async (flag) => {
    // setFlag(false);

    const url = `${process.env.REACT_APP_API_URL}/contacts/edit`;

    try {
      const { data } = await api.post(url, { id: contactId });
      const {
        companies = [],
        provinces = [],
        contact,
        user_logged,
        document_types = [],
        observations_contact,
        multiple_contacts = [],
        multiple_clients = [],
      } = data;

      console.log(data);

      multiple_contacts?.length === 0 && !contact
        ? setFlagContactNoExistence(true)
        : setFlagContactNoExistence(false);

      const sameNifContacts = contact?.nif
        ? multiple_contacts.filter((c) => c.nif === contact?.nif && c.nif != "")
        : [];

      console.log(sameNifContacts);

      setSameNifForbidden(sameNifContacts);

      setMultipleContacts(
        Array.isArray(multiple_contacts) && multiple_contacts?.length > 0
          ? multiple_contacts
          : [],
      );
      setMultipleClients(
        Array.isArray(multiple_clients) && multiple_clients?.length > 1
          ? multiple_clients
          : [],
      );

      if (multiple_clients?.length == 1) {
        setAssociatedClient(multiple_clients[0]);
      }

      setUserLogged(user_logged);

      // Transform notes
      const transformedNotes = nuevoArrayDeNotas(observations_contact) || {
        conClave: [],
        sinClave: [],
      };
      const resultadoFinal = [
        ...(Array.isArray(transformedNotes.conClave)
          ? transformedNotes.conClave
          : []),
        ...(Array.isArray(transformedNotes.sinClave)
          ? transformedNotes.sinClave
          : []),
      ];

      if (!contact) {
        setFlagContactNoExistence(true);
        console.error(
          "No se encontró el contacto o la respuesta del servidor es incorrecta - editar contacto",
        );
        return;
      }

      // Estado base
      setStatuses(arrayToStatus);
      setMarketingToSend(contact.marketing || 0);
      setMarketingToShow(Boolean(contact.marketing));
      // setDateInDefault(dayjs(new Date(contact?.date_in)));
      setDateInDefault(dayjs(new Date()));

      // Helpers
      const getRelation = (relation, defaultObj) =>
        relation?.id && relation.id !== 0 ? relation : defaultObj;
      const getProvince = (relation) =>
        relation?.id_provincia && relation.id_provincia !== 0
          ? relation
          : { provincia: "Seleccionar", id_provincia: 0 };

      // Construcción del estado del contacto
      const contactDataMap = {
        lawyer: getRelation(contact?.lawyers_relation, {
          name: "Seleccionar",
          surname: "",
        }),
        assignTo: getRelation(contact?.assigned_relation, {
          name: "Seleccionar",
          surname: "",
        }),
        status: flag
          ? { nombre: "Cliente", id: 2 }
          : (arrayToStatus.find((s) => s.id === contact?.status) ?? {
              nombre: "Pte Llamada",
              id: 0,
            }),
        company: getRelation(contact?.company_relation, {
          company_name: "Seleccionar",
          id: 0,
        }),
        email: contact?.email ?? "",
        id: contact?.id ?? null,
        name: contact?.name ?? "",
        surname: contact?.surname ?? "",
        address: contact?.address ?? "",
        postalcode: contact?.postalcode ?? "",
        nif: contact?.nif ?? "",
        old_document: contact?.nif ?? "",
        old_email: contact?.email ?? "",
        document_type: getRelation(contact?.document_types_relation, {
          name: "Seleccionar",
          id: 0,
        }),
        phone: contact?.phone ?? "",
        province: getProvince(contact?.provinces_relation),
        asociation: getRelation(contact?.asociations_relation, {
          asoc_name: "Seleccionar",
          id: 0,
        }),
        case_type: getRelation(contact?.types_relation, {
          case_type: "Seleccionar",
          id: 0,
        }),
        cards: resultadoFinal.length > 0 ? resultadoFinal : [],
        conditions: contact?.condiciones?.replaceAll("<br />", "\n") ?? "",
        marketingToShow: contact?.marketing ?? 0,
        marketing: contact?.marketing ?? 0,
        date_in: contact?.date_in ?? "",
      };

      // console.log(contactDataMap);
      // console.log(flag);

      setOldContactData(contactDataMap);

      Object.entries(contactDataMap).forEach(([key, value]) =>
        updateContactData(key, value),
      );

      setOptions({
        companies: [{ company_name: "Seleccionar", id: 0 }, ...companies],
        provinces: [
          { provincia: "Seleccionar", id_provincia: 0 },
          ...provinces,
        ],
        status: [{ nombre: "Seleccionar", id: 0 }, ...arrayToStatus],
        document_type: [{ name: "Seleccionar", id: 0 }, ...document_types],
      });

      filterDataByCompany(contact?.company_relation?.id);

      ////////////////////////////// HANDLING //////////////////////////////
      var cleaner = false;

      cleaner = await notesHistoricLogic(
        contact,
        multiple_clients?.length == 1 ? multiple_clients[0] : null,
        setDifferentNotes,
      );

      // console.log(multiple_clients);
      // console.log(multiple_clients[0]?.id);
      // console.log(
      //   contact?.company_relation?.id == multiple_clients[0]?.company_id,
      // );

      if (
        multiple_clients.length === 1 &&
        multiple_clients[0]?.id &&
        contact?.company_relation?.id == multiple_clients[0]?.company_id
      ) {
        const client = multiple_clients[0];
        const flagCli = client?.nif == contact?.nif;

        setFlagClientFounded(client);
        setFlagSameDocument(flagCli);
      }

      if (cleaner) setFlagToReload((prev) => !prev);
      ////////////////////////////// HANDLING //////////////////////////////
    } catch (error) {
      setFlagContactNoExistence(true);
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setFlag(true);
    }
  };

  const guardarContacto = async (updateClientFromDocument = false) => {
    const fields = {
      contact_id: contactId || 0,
      lawyer: contactData?.lawyer?.id || 0,
      user_id: contactData?.assignTo?.id || 0,
      company_id: contactData?.company?.id || 0,
      email: contactData?.email || "",
      name: contactData?.name || "",
      surname: contactData?.surname || "",
      postalcode: contactData?.postalcode || "",
      nif: contactData?.nif || "",
      document_type: contactData?.document_type?.id || 0,
      phone: contactData?.phone || "",
      province: contactData?.province?.id_provincia
        ? contactData?.province?.provincia
        : "",
      asociation: contactData?.asociation?.id || 0,
      case_type: contactData?.case_type?.id || 0,
      status: contactData?.status?.id || 0,
      condiciones: (contactData?.conditions).replace(/\n/g, "<br />") || "",
      marketing: marketingToSend || 0,
      address: contactData?.address || "",
    };
    console.log(fields);

    const formData = new FormData();
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v));

    if (updateClientFromDocument == false) {
      const confirm = await Swal.fire({
        title: "¿Desea guardar los cambios?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Continuar",
        denyButtonText: "Volver",
        reverseButtons: true,
        confirmButtonColor: "#1ab394",
      });
      if (!confirm.isConfirmed) return;
    }

    try {
      Swal.fire({
        title: "Guardando información...",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/contacts/update`,
        formData,
      );

      console.log(response);

      Swal.fire({
        title: "¡Contacto guardado correctamente!",
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      }).then(() => navigate("/contactos/ver?id=" + contactId));
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "No se pudo guardar el contacto",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleUpdateClient = async () => {
    const fields = {
      nif: contactData?.nif,
      id: flagClientFounded?.id,
    };

    // console.log(flagClientFounded);

    const formData = new FormData();
    Object.entries(fields).forEach(([k, v]) => {
      if (v !== undefined && v !== null) {
        formData.append(k, v);
      }
    });

    const { isConfirmed } = await Swal.fire({
      title: "¿Actualizar documento del cliente asociado?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Continuar",
      denyButtonText: "Volver",
      reverseButtons: true,
      confirmButtonColor: "#1ab394",
    });

    if (!isConfirmed) return false;

    // Loader persistente
    Swal.fire({
      title: "Guardando información...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/users/update`,
        formData,
      );

      Swal.fire({
        title: "Éxito",
        icon: "success",
        text: "Cliente actualizado correctamente",
        confirmButtonColor: "#1ab394",
      });

      return response.data;
    } catch (error) {
      // 🧠 Extraer mensaje real del backend si existe
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "No se pudo guardar el cliente";

      Swal.fire({
        title: "Error",
        icon: "error",
        text: message,
        confirmButtonColor: "#d33",
      });

      console.error("Update client error:", error);
      return false;
    }
  };

  const handleContactsFormInformation = async () => {
    const baseUrl = `${process.env.REACT_APP_API_URL}/contacts/search`;

    const queryParams = {
      company_id: contactData?.company?.id,
      email: contactData?.email ?? "",
      document: contactData?.nif ?? "",
      phone: contactData?.phone ?? "",
      id: contactData?.id ?? "",
    };

    const importantChanges = hasImportantChanges(contactData, oldContactData);

    const normalInfoChanges = hasNormalContactChanges(
      contactData,
      oldContactData,
    );

    const noChangesDetected = !importantChanges && !normalInfoChanges;

    if (noChangesDetected) {
      Swal.fire({
        title: "Sin cambios",
        text: "No se ha detectado ningún cambio en la información del contacto.",
        icon: "info",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    // console.log(flagSameDocument, contactData?.nif, oldContactData?.nif);
    if (flagSameDocument && contactData?.nif !== oldContactData?.nif) {
      const decision = await Swal.fire({
        title: "¡Cuidado!",
        html: `
      <div style="text-align: left;">
      <p>
        Ha cambiado el <b>Documento</b> y ya existe un cliente asociado
        a este contacto con el mismo documento.
      </p>
      <p>
        Si continúa, el contacto <b>perderá la relación</b> y no podrá
        compartir notas.
      </p>
      <p>
        <b>Recomendación:</b> Actualice el documento del cliente para mantener la relación.
      </p>
      </div>
    `,
        icon: "warning",
        showDenyButton: true,
        showCancelButton: true,

        confirmButtonText: "Continuar",
        denyButtonText: "Actualizar cliente y continuar",
        cancelButtonText: "Cancelar",

        confirmButtonColor: "#1ab394", // rojo → acción destructiva
        denyButtonColor: "#0288d1", // verde → recomendada
        cancelButtonColor: "#d33",

        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true,
      });

      //  Cancelar → no hace nada
      if (decision.dismiss === Swal.DismissReason.cancel) return;

      // Actualizar cliente (recomendado)
      if (decision.isDenied) {
        var updateClient = await handleUpdateClient();

        // console.log(updateClient);
        if (!updateClient) return;

        await Swal.fire({
          title: "Cliente actualizado",
          text: "Actualizando contacto...",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }

      // Continuar → rompe relación
      if (decision.isConfirmed) {
        // continuar flujo normal
      }
    }

    let canContinue = true;

    /* =====================================================
     * BUSCAR DUPLICADOS
     * ===================================================== */
    if (importantChanges) {
      canContinue = await buscarDuplicados({
        baseUrl,
        queryParams,
        contactId,
        setContactData,
        incomingSite: "contactos",
      });

      if (!canContinue) return;
    }

    /* ================= VALIDACIONES ================= */
    if (contactData?.company?.id === 0) {
      Swal.fire({
        title: "¡Seleccione una empresa!",
        icon: "warning",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    /* =====================================================
     * VALIDACIÓN Y UPDATE
     * ===================================================== */
    const requiredFields = {
      user_id: !contactData?.assignTo?.id,
      name: !contactData?.name,
      surname: !contactData?.surname,
      phone: !contactData?.phone,
      case_types: !contactData?.case_type?.id,
      company: !contactData?.company?.id,
    };

    if (Object.values(requiredFields).includes(true)) {
      const labels = {
        user_id: "Asignar a",
        name: "Nombre",
        surname: "Apellido",
        phone: "Teléfono",
        case_types: "Tipo de caso",
      };

      const missing = Object.keys(requiredFields)
        .filter((k) => requiredFields[k])
        .map((k) => `<li>${labels[k]}</li>`)
        .join("");

      return Swal.fire({
        title: "Campos incompletos",
        icon: "error",
        confirmButtonColor: "#1ab394",
        html: `<ul style="text-align:left">${missing}</ul>`,
      });
    }

    await guardarContacto(updateClient || false);
  };

  const handleFormContactsToClient = async () => {
    const baseUrl = `${process.env.REACT_APP_API_URL}/users/searchclient`;
    const queryParams = {
      email: contactData?.email ?? "",
      document: contactData?.nif ?? "",
      phone: contactData?.phone ?? "",
      id: contactData?.id ?? "",
    };

    const importantChanges = hasImportantChanges(contactData, oldContactData);

    var canContinue = true;

    /* ================= BUSCAR DUPLICADOS ================= */
    if (importantChanges) {
      const resultSearch = await buscarDuplicados({
        baseUrl,
        queryParams,
        contactId,
        setContactData,
        incomingSite: "clientes",
      });

      if (!resultSearch) return;

      const hasRepeatedNifBetweenContactsAndClients =
        Array.isArray(resultSearch?.clients) &&
        resultSearch?.clients?.length > 0 &&
        !!contactData?.nif &&
        resultSearch.clients.some((client) => client?.nif === contactData?.nif);

      console.log(hasRepeatedNifBetweenContactsAndClients);

      if (hasRepeatedNifBetweenContactsAndClients) {
        canContinue = false;

        await Swal.fire({
          title: "¡Error!",
          text: "¡Se ha detectado otro cliente con el mismo documento. Este debe ser un registro único por usuario. Por favor ingrese un documento diferente.!",
          icon: "error",
          confirmButtonColor: "#1ab394",
        });

        return;
      }

      canContinue = true;
    }

    /* ================= VALIDACIONES ================= */
    if (contactData?.company?.id === 0) {
      Swal.fire({
        title: "¡Seleccione una empresa!",
        icon: "warning",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    /* =====================================================
     * VALIDACIÓN Y UPDATE
     * ===================================================== */

    const requiredFields = {
      name: !contactData?.name,
      surname: !contactData?.surname,
      address: !contactData?.address,
      postalcode: !contactData?.postalcode,
      nif: !contactData?.nif,
      phone: !contactData?.phone,
      email: !contactData?.email,
      lawyer: !contactData?.lawyer?.id,
      company: !contactData?.company?.id,
      // assignTo: !contactData?.assignTo?.id,
      document: !contactData?.nif,
      document_type: !contactData?.document_type?.id,
      case_type: !contactData?.case_type?.id,
      status: !contactData?.status?.id,
    };

    if (Object.values(requiredFields).includes(true)) {
      const labels = {
        name: "Nombre",
        surname: "Apellido",
        address: "Dirección",
        postalcode: "Código postal",
        nif: "Documento",
        phone: "Teléfono",
        email: "Email",
        lawyer: "Abogado",
        company: "Empresa",
        document: "Documento",
        document_type: "Tipo de documento",
        case_type: "Tipo de caso",
        status: "Estado",
      };

      const missing = Object.keys(requiredFields)
        .filter((k) => requiredFields[k])
        .map((k) => `<li>${labels[k]}</li>`)
        .join("");

      return Swal.fire({
        title: "Campos incompletos",
        icon: "error",
        confirmButtonColor: "#1ab394",
        html: `<ul style="text-align:left">${missing}</ul>`,
      });
    }

    const { isConfirmed } = await Swal.fire({
      title: "Convertir contacto en cliente",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Sí",
      denyButtonText: "No",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    });

    if (!isConfirmed) return;

    try {
      const params = {
        lawyer: contactData?.lawyer.id,
        company_id: contactData?.company?.id,
        email: contactData?.email,
        name: contactData?.name,
        surname: contactData?.surname,
        postalcode: contactData?.postalcode,
        nif: contactData?.nif,
        document_type: contactData?.document_type?.id,
        phone: contactData?.phone,
        province: contactData?.province?.provincia || "",
        asociation: contactData?.asociation?.id || 0,
        contact_id: contactId,
        zone: 0,
        status: 1,
        marketing: marketingToSend,
        address: contactData?.address,
      };

      console.log(params);

      const formDataClient = new FormData();
      Object.entries(params).forEach(([k, v]) => formDataClient.append(k, v));

      Swal.fire({
        title: "Creando cliente...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const { data: clientResponse } = await api.post(
        `${process.env.REACT_APP_API_URL}/users/store`,
        formDataClient,
      );

      const contactUpdated = await guardarContacto(false);

      Swal.close();

      if (contactUpdated) {
        console.log("contacto actualizado:" + contactUpdated);
      }

      if (clientResponse?.error) {
        return Swal.fire({
          title: "Error",
          icon: "error",
          confirmButtonColor: "#1ab394",
          text: "El cliente ya existe o ocurrió un error.",
        });
      }

      const formDataUpdateNotesNifToTransfer = new FormData();
      formDataUpdateNotesNifToTransfer.append("contact_id", contactId);
      formDataUpdateNotesNifToTransfer.append("document", contactData?.nif);

      // Mostrar loading
      Swal.fire({
        title: "Transfiriendo notas...",
        text: "Por favor espera un momento",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/contacts/update_historical_contact_to_client`,
        formDataUpdateNotesNifToTransfer,
      );

      console.log(response, "notas actualizadas");

      Swal.fire({
        title: "¡Cliente creado!",
        icon: "success",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Ver cliente",
      }).then(() => {
        navigate(`/clientes/ver?id=${clientResponse.client_created.id}`);
      });
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        title: "Error",
        icon: "error",
        confirmButtonColor: "#1ab394",
        text: "Ocurrió un problema al convertir el contacto.",
      });
    }
  };

  const handleContactsToHistorical = async () => {
    // console.log(dateInFilter);
    const dateUpdate = new Date();
    const newDateUpdate = dayjs(dateUpdate).format("YYYY-MM-DD HH:mm:ss"); // Devuelve "2024-11-24"

    const formDataHistorical = new FormData();
    const formDataNewContact = new FormData();

    if (selectedCheckboxNotes == "") {
      Swal.fire({
        title: "¡Error!",
        icon: "warning",
        text: "Por favor seleccione el tipo de nota.",
        showDenyButton: false,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    } else if (valCaseTypeForm.trim() == "") {
      Swal.fire({
        title: "¡Error!",
        icon: "warning",
        text: "No se ha agregado ningún texto a la nota",
        showDenyButton: false,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    } else {
      // Define la estructura de como se va a visualizar la ultima nota, la cual esta guardada sobre el mismo registro del contacto,
      // el resto de registros serán guardados en el historico

      // console.log(associatedClient?.length > 0);

      const historicalData = {
        contact_id: contactId,
        client_id: associatedClient?.id ? associatedClient?.id : 0,
        created_by: userLogged.id
          ? userLogged.id || "" + userLogged.id || ""
          : 0,
        notas: valCaseTypeForm?.replace(/\n/g, "<br />"),
        created_at: dateInFilter
          ? dayjs(dateInFilter).format("YYYY-MM-DD HH:mm:ss")
          : newDateUpdate,
        case_type: contactData?.case_type?.id || 0,
        lawyer: contactData?.lawyer?.id || 0,
        user_id: contactData?.assignTo?.id || 0,
        company_id: contactData?.company?.id || 0,
        status: contactData?.status?.id || 0,
        title: titleObservation || "",
        note_type: selectedCheckboxNotes || "none",
        document: contactData?.nif || "",
      };

      const newDataContact = {
        contact_id: contactId,
        client_id: associatedClient?.id ? associatedClient?.id : 0,
        status: contactData?.status?.id || 0,
        case_type: contactData?.case_type?.id || 0,
        lawyer: contactData?.lawyer?.id || 0,
        user_id: contactData?.assignTo?.id || 0,
        company_id: contactData?.assignTo?.company_id || 0,
        date_update: newDateUpdate,
      };

      Object.entries(historicalData).forEach(([key, value]) => {
        formDataHistorical.append(key, value);
      });

      Object.entries(newDataContact).forEach(([key, value]) => {
        formDataNewContact.append(key, value);
      });

      Swal.fire({
        title: "¿Desea guardar la nota?",
        // text: "Esta acción creará un nuevo registro de contacto y adicionalmente modificará el contacto actual con los valores seleccionados.",
        showDenyButton: true,
        icon: "warning",
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Guardar",
        denyButtonText: "Volver",
        preConfirm: () => {
          try {
            const historical = api
              .post(
                `${process.env.REACT_APP_API_URL}/contacts/create_historical`,
                formDataHistorical,
              )
              .then((response) => {
                console.log(response);
              });
            console.log(historical);

            const contactUpdate = api
              .post(
                `${process.env.REACT_APP_API_URL}/contacts/update_contact_from_historical`,
                formDataNewContact,
              )
              .then((response) => {
                console.log(response);
              });
            console.log(contactUpdate);
          } catch (error) {
            console.log(error);
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "¡Guardado!",
            icon: "success",
            html: "¿Seguir editando?",
            showDenyButton: true,
            confirmButtonText: "Sí",
            denyButtonText: "Volver",
            confirmButtonColor: "#1ab394",
            cancelButtonColor: "#d33",
            reverseButtons: true,
          }).then((result) => {
            if (result.isDenied) {
              navigate("/contactos");
            } else {
              setShowNotes(false);
              setValCaseTypeForm("");
              setSelectedCheckboxNotes("");
              setChangeRender(!changeRender);
            }
          });
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "error");
          setDateInFilter(false);
        }
      });
    }
  };

  const handleChangeCheckbox = (event) => {
    if (event.target.checked == true) {
      setMarketingToSend(1);
      setMarketingToShow(true);
    } else {
      setMarketingToSend(0);
      setMarketingToShow(false);
    }
  };

  //////////////////// LOW BUTTONS ///////////////////////
  const caseTypeFunctionChange = (case_id) => {
    var texto_incapacidad =
      "Fecha nacimiento(edad):\nEstado Civil:\nHijos a su cargo:\nSituación Laboral (Funciones que desempeña en su caso):\n¿Alguna Invalidez otorgada o en trámite?:\n¿Cobra dependencia o alguna otra pensión? (En caso afirmativo indicar el tipo de pensión):\n¿Ha presentado recientemente alguna solicitud?\n¿Tiene resolución?\n¿En qué fecha le fue comunicada?";
    if (case_id === 9 || case_id === 6 || case_id === 10 || case_id === 11) {
      setValCaseTypeForm(texto_incapacidad);
    } else {
      setValCaseTypeForm(" ");
    }

    // $("#notas").html(texto_incapacidad);
    // } else {
    //   $("#notas").text("");
  };

  // Función para actualizar valores específicos del contacto
  const updateContactData = (key, value) => {
    console.log(value);

    setContactData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleChangeDateIn = (newValue) => {
    if (newValue && dayjs.isDayjs(newValue)) {
      // Agrega la hora actual al objeto dayjs de la fecha seleccionada
      const dateWithCurrentTime = newValue
        .hour(dayjs().hour())
        .minute(dayjs().minute())
        .second(dayjs().second());

      // Convierte el objeto dayjs con hora a un string en el formato deseado
      const formattedDate = dateWithCurrentTime.format("YYYY-MM-DD HH:mm:ss");

      setDateInDefault(dateWithCurrentTime); // Guarda la fecha con hora
      setDateInFilter(formattedDate); // Guarda la fecha como string con hora
    } else {
      setDateInFilter(null);
      console.error("El nuevo valor no es un objeto dayjs");
    }
  };

  const buildSearchClientUrl = (email = null, nif = null) => {
    return {
      email: contactData?.email ? contactData?.email : email,
      document: contactData?.nif ? contactData?.nif : nif,
    };
  };

  //////////////////// FILTER BY COMPANY  ///////////////////////
  const filterDataByCompany = (company_id, flagFromCompanyInput = false) => {
    if (company_id) {
      try {
        let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

        api.post(queryUrl, { company: company_id }).then((response) => {
          if (response.data) {
            const { cases_types, associations, lawyers } = response.data;

            setOptions((prevData) => ({
              ...prevData,
              assignTo: [{ name: "Seleccionar", surname: "" }, ...lawyers],
              lawyer: [{ name: "Seleccionar", surname: "" }, ...lawyers],
              asociations: [{ asoc_name: "Ninguno", id: 0 }, ...associations],
              caseTypes: [{ case_type: "Seleccionar", id: 0 }, ...cases_types],
            }));

            if (flagFromCompanyInput == true) {
              const defaultValues = {
                assignTo: { name: "Seleccionar", surname: "" },
                lawyer: { name: "Seleccionar", surname: "" },
                asociation: { asoc_name: "Ninguno", id: 0 },
                case_type: { case_type: "Seleccionar", id: 0 },
              };

              Object.entries(defaultValues).forEach(([key, value]) =>
                updateContactData(key, value),
              );
            }

            setChangeOptionsFlag(!changeOptionsFlag);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fieldsConfigLeft = useMemo(() => {
    const fieldsCommonConfig = [
      {
        key: "companyId",
        type: "autocomplete",
        value: contactData?.company || null,
        label: "Empresa",
        className: "companyId",
        disabled: showNotes,
        open: openOptions.companies,
        options: options.companies,
        loading: loadingOptions.companies,
        onChange: (event, value) => {
          updateContactData(
            "company",
            value
              ? {
                  id: value.id,
                  company_name: value.company_name,
                }
              : null,
          );

          filterDataByCompany(value?.id || 0, true);
        },
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => `${option.company_name}`,
      },
      {
        key: "assignTo",
        type: "autocomplete",
        value: contactData?.assignTo || null,
        label: "Asignar a",
        className: "assignToId",
        open: openOptions.assignTo,
        id: "assignToId",
        options: options.assignTo,
        loading: loadingOptions.assignTo,
        onChange: (event, value) =>
          updateContactData(
            "assignTo",
            value
              ? {
                  id: value.id,
                  name: value.name,
                  surname: value.surname,
                  company_id: value.company_id,
                }
              : null,
          ),
        isOptionEqualToValue: (option, value) => option.id === value?.id,
        getOptionLabel: (option) => `${option.name} ${option.surname}`,
      },
      {
        key: "lawyer",
        type: "autocomplete",
        value: contactData?.lawyer || null,
        label: "Abogado",
        className: "lawyerId",
        id: "lawyerId",
        open: openOptions.lawyer,
        options: options.lawyer,
        loading: loadingOptions.lawyer,
        onChange: (event, value) =>
          updateContactData(
            "lawyer",
            value
              ? {
                  id: value.id,
                  name: value.name,
                  surname: value.surname,
                  company_id: value.company_id,
                }
              : null,
          ),
        isOptionEqualToValue: (option, value) =>
          option.name + " " + option.surname ===
          value?.name + " " + value?.surname,
        getOptionLabel: (option) => `${option.name} ${option.surname}`,
      },
      {
        type: "text",
        label: "Nombre",
        value: contactData?.name || "",
        id: "name",
        disabled: showNotes,
        onChange: (event, value) =>
          updateContactData(
            "name",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Apellido",
        value: contactData?.surname || "",
        id: "surname",
        disabled: showNotes,
        onChange: (event, value) =>
          updateContactData(
            "surname",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        key: "caseTypeName",
        type: "autocomplete",
        value: contactData?.case_type || null,
        label: "Tipo de caso",
        id: "caseTypeId",
        className: "caseTypeId",
        open: openOptions.caseTypes,
        options: options.caseTypes,
        loading: loadingOptions.caseTypes,
        onChange: (event, value) => {
          updateContactData("case_type", value || null);
          if (value) {
            caseTypeFunctionChange(value.id);
          }
        },

        isOptionEqualToValue: (option, value) =>
          option.case_type === value?.case_type,
        getOptionLabel: (option) => option.case_type,
      },
      {
        key: "status",
        value: contactData?.status || null,
        type: "autocomplete",
        label: "Estado",
        className: "status",
        id: "status",
        open: openOptions.status,
        options: options.status,
        loading: loadingOptions.status,
        onChange: (event, value) => {
          updateContactData("status", value || null);
        },
        isOptionEqualToValue: (option, value) =>
          option.nombre === value?.nombre,
        getOptionLabel: (option) => option.nombre,
      },
    ];

    // Si la columna de estado debe estar visible, la añadimos
    if (!showNotes) {
      fieldsCommonConfig.splice(5, 0, {
        type: "text",
        label: "Teléfono",
        value: contactData?.phone || "",
        id: "phone",
        inputType: "number",
        onChange: (event, value) =>
          updateContactData(
            "phone",
            event.target.value != null ? event.target.value : "",
          ),
      });
      fieldsCommonConfig.splice(6, 0, {
        type: "text",
        label: "Email",
        value: contactData?.email || "",
        id: "email",
        onChange: (event, value) =>
          updateContactData(
            "email",
            event.target.value != null ? event.target.value : "",
          ),
      });
      fieldsCommonConfig.splice(7, 0, {
        type: "text",
        label: "Dirección",
        value: contactData?.address || "",
        id: "address",
        onChange: (event, value) =>
          updateContactData(
            "address",
            event.target.value != null ? event.target.value : "",
          ),
      });
      fieldsCommonConfig.splice(8, 0, {
        type: "text",
        label: "Código postal",
        value: contactData?.postalcode != null ? contactData?.postalcode : "",
        id: "postalcode",
        onChange: (event) => {
          updateContactData(
            "postalcode",
            event.target.value != null ? event.target.value : "",
          );
        },
        inputProps: {
          maxLength: 5,
        },
      });
      fieldsCommonConfig.splice(9, 0, {
        key: "province",
        id: "province",
        value: contactData?.province || null, // Usar una cadena vacía si es null o undefined
        type: "autocomplete",
        label: "Provincia",
        className: "selectWithInput",
        open: openOptions.provinces,
        options: options.provinces,
        loading: loadingOptions.provinces,
        onChange: (event, value) => updateContactData("province", value || ""), // También manejar el valor como cadena vacía
        isOptionEqualToValue: (option, value) =>
          option.provincia === value?.provincia,
        getOptionLabel: (option) => option.provincia,
      });
      fieldsCommonConfig.splice(10, 0, {
        id: "document_type",
        key: "document_type",
        value: contactData?.document_type,
        type: "autocomplete",
        label: "Tipo",
        className: "documentTypeId",
        open: openOptions.document_type,
        options: options.document_type,
        loading: loadingOptions.document_type,
        onChange: (event, value) => {
          updateContactData("document_type", value || null);
        },
        isOptionEqualToValue: (option, value) => option.name === value?.name,
        getOptionLabel: (option) => option.name,
      });
      fieldsCommonConfig.splice(11, 0, {
        type: "text",
        label: "Documento de identidad",
        value: contactData?.nif || "", // Usar una cadena vacía si es null o undefined
        id: "nif",
        onChange: (event, value) =>
          updateContactData("nif", event.target.value || ""), // También manejar el valor como cadena vacía
      });
      fieldsCommonConfig.splice(12, 0, {
        key: "asociation",
        value: contactData?.asociation,
        type: "autocomplete",
        label: "Asociaciones",
        className: "asociationsId",
        open: openOptions.asociations,
        options: options.asociations,
        loading: loadingOptions.asociations,
        onChange: (event, value) => {
          updateContactData("asociation", value || null);
        },
        isOptionEqualToValue: (option, value) =>
          option.asoc_name === value?.asoc_name,
        getOptionLabel: (option) => option.asoc_name,
      });
      fieldsCommonConfig.splice(13, 0, {
        type: "text",
        label: "Condiciones especiales",
        value: contactData?.conditions,
        onChange: (event) =>
          updateContactData("conditions", event.target.value),
      });
    } else {
      if (selectedCheckboxNotes == "contact-register") {
        fieldsCommonConfig.splice(14, 0, {
          type: "date",
          label: "Nueva fecha de ingreso",
          foco: true,
          helpText:
            "Solo modificar si se desea guardar en una fecha específica. Por defecto se guardará la fecha de hoy.",
          value: dateInDefault,
          id: "date_in",
          disabled: true,
          onChange: (event, value) =>
            updateContactData("date_in", event.target.value),
        });
      }
    }

    return fieldsCommonConfig;
  }, [showNotes, contactData, changeOptionsFlag, selectedCheckboxNotes]); // Dependencia para que se actualice al cambiar el estado

  const xsValues = {
    nif: 8,
    document_type: 4,
    name: 6,
    surname: 6,
    postalcode: 6,
    province: 6,
    assignToId: 6,
    lawyerId: 6,
    caseTypeId: 6,
    phone: 6,
    email: 6,
    status: 6,
  };

  const commonButtonProps = {
    size: "small",
    sx: { width: "100%", padding: "5px 20px !important" },
  };

  const handleChangeSelectedNewNoteType = (event) => {
    setSelectedCheckboxNotes(
      event?.target?.value == 1 ? "normal" : "contact-register",
    );

    // setContactDataHistorical((prev) => ({
    //   ...prev,
    //   ["note_type"]: event?.target?.value == 1 ? "normal" : "contact-register",
    // }));
  };
  //////////////////// SPECIAL BUTTOM CREATE CLIENT CONTROL ///////////////////////

  const isClientFlow = getFlag == "true";

  const hasPermission = isClientFlow
    ? can("clients", "add")
    : can("contacts", "edit");

  const canEdit = hasPermission;
  const noContactData = !contactData || !contactData?.name;

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    if (isClientFlow) {
      setFlagToClient(true);
    }

    getDataList(isClientFlow);
  }, [changeRender, showNotes, contactId, flagToReload, can]);

  const uniqueRelation =
    flagSameDocument &&
    flagClientFounded?.id &&
    flagClientFounded?.company_id == contactData?.company?.id;

  // console.log(uniqueRelation);

  // console.log(
  //   flagSameDocument,
  //   flagClientFounded,
  //   flagClientFounded?.company_id,
  //   contactData,
  // );

  return (
    <div className="fatherContainer">
      <CommonSubHeader
        title="Contactos"
        subTitle={isClientFlow ? "Covertir a Cliente" : "Editar"}
      />

      {noContactData && flagContactNoExistence && (
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <Alert severity="error">El contacto no existe...</Alert>
          </Grid>
        </Grid>
      )}

      {!canEdit && <Unauthorized />}

      {flag && canEdit && contactData && (
        <LoadingPage isLoading={!flag} heightProp={"600px"} />
      )}

      {flag && canEdit && contactData && (
        <Fade timeout={600} in>
          <Grid container>
            <Grid item xs={12}>
              {uniqueRelation && (
                <Grid item xs={12}>
                  <Alert severity="info" className="alertStyles">
                    <span>
                      Se ha encontrado un cliente asociado a este contacto,
                      tambien puede agregar sus observaciones aquí:
                    </span>
                    <Button
                      component={NavLink}
                      to={`/clientes/ver?id=${flagClientFounded?.id}`}
                      size="small"
                      color="info"
                      variant="outlined"
                      sx={{ marginLeft: "20px" }}>
                      Ver Cliente
                    </Button>
                  </Alert>
                </Grid>
              )}

              <Grid container spacing={1} sx={{ padding: "10px 40px" }}>
                {multipleContacts?.length > 0 && (
                  <DuplicatedAlertList
                    items={multipleContacts}
                    entityName="contacto"
                    createNoteButton={true}
                  />
                )}
                {multipleClients?.length > 1 && (
                  <DuplicatedAlertList
                    items={multipleClients}
                    entityName="cliente"
                  />
                )}
              </Grid>
            </Grid>

            <Box
              component="form"
              sx={{ margin: "auto", "& > :not(style)": {} }}
              noValidate
              autoComplete="off"
              className="formMainContainer">
              <Alert sx={{ marginBottom: "20px" }} color="info" severity="info">
                <Typography sx={{ fontWeight: "600", marginRight: "10px" }}>
                  NOTA IMPORTANTE:
                </Typography>
                <Typography>
                  Para buscar contactos duplicados, basta con ingresar la
                  empresa + el correo, la identificación o el teléfono y
                  presionar Guardar.
                </Typography>
              </Alert>

              <Grid container spacing={2} className="fontSize">
                <Grid container item xs={5} spacing={1}>
                  {fieldsConfigLeft.map((field) =>
                    field.type == "text" ? (
                      <Grid
                        item
                        xs={xsValues[field.id] || 12}
                        key={`fieldsConfig-grid-${field.id}`}>
                        <TextField
                          value={field.value}
                          id={field.id}
                          label={field.label}
                          disabled={field.disabled}
                          onChange={field.onChange}
                          type={field.inputType ? field.inputType : "text"}
                          size="small"
                          variant="outlined"
                          className="inputFormCreate"
                          inputProps={{
                            ...field.inputProps,
                            onInput: (event) => {
                              if (
                                event.target.value.length > 5 &&
                                field.label === "postalcode"
                              ) {
                                event.target.value = event.target.value.slice(
                                  0,
                                  5,
                                );
                              }
                            },
                          }}
                        />
                      </Grid>
                    ) : field.type == "date" ? (
                      <Grid item xs={12} key={`fieldsConfig-grid-${field.id}`}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es">
                          <DesktopDatePicker
                            disabled={!showNotes}
                            value={field.value}
                            id={field.id}
                            label={field.label}
                            onChange={(value) => handleChangeDateIn(value)}
                            sx={{ width: "100%", marginBottom: "7px" }}
                            slotProps={{
                              textField: {
                                helperText: field.helpText,
                                autoFocus: field?.foco ?? false,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    ) : (
                      <Grid
                        item
                        xs={xsValues[field.id] || 12}
                        key={`formFieldsAut-grid-${field.key}`}>
                        <FormControl className="inputFormCreate">
                          <Autocomplete
                            key={`formFieldsAut-${field.key}`}
                            value={field.value}
                            disabled={field.disabled}
                            className={field.className}
                            size="small"
                            options={field.options || []}
                            onChange={field.onChange}
                            isOptionEqualToValue={field.isOptionEqualToValue}
                            getOptionLabel={field.getOptionLabel}
                            renderOption={(props, option) => (
                              <li {...props} key={getOptionKey(option)}>
                                {field.getOptionLabel(option)}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={field.label}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <Fragment>
                                      {field.loading ? (
                                        <CircularProgress
                                          color="inherit"
                                          size={20}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </Fragment>
                                  ),
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                    ),
                  )}

                  {showNotes && (
                    <>
                      <Divider sx={{ width: "100%", mb: "10px" }} />

                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            opacity: showNotes ? 1 : 0.6,
                            pointerEvents: showNotes ? "auto" : "none",
                            transition: "0.3s",
                          }}>
                          <CardContent>
                            {!showNotes && (
                              <Box textAlign="center">
                                <Button
                                  variant="contained"
                                  color="info"
                                  size="small"
                                  sx={{ width: "50%", fontWeight: 700 }}
                                  disabled={differentNotes?.length > 0}
                                  onClick={() => {
                                    setShowNotes(true);
                                    setValCaseTypeForm("");
                                  }}>
                                  {differentNotes?.length > 0
                                    ? "NOTAS DESHABILITADAS"
                                    : "Crear Nota"}
                                </Button>
                              </Box>
                            )}

                            <Divider sx={{ mb: 2 }} />

                            {!showNotes && differentNotes?.length > 0 && (
                              <Alert severity="warning" sx={{ mb: 2 }}>
                                El cliente y el contacto tienen notas
                                diferentes.
                                <ContactClientNotesComparisonDialog
                                  notas={differentNotes}
                                  client={flagClientFounded || []}
                                  contact={contactData || []}
                                  setFlagToReload={setFlagToReload}
                                  flagToReload={flagToReload}
                                />
                              </Alert>
                            )}

                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <Box display="flex" gap={2}>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={
                                          selectedCheckboxNotes === "normal"
                                        }
                                        onChange={
                                          handleChangeSelectedNewNoteType
                                        }
                                        value={"1"}
                                      />
                                    }
                                    label="Anotación normal"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        color="success"
                                        checked={
                                          selectedCheckboxNotes ===
                                          "contact-register"
                                        }
                                        onChange={
                                          handleChangeSelectedNewNoteType
                                        }
                                        value={"2"}
                                      />
                                    }
                                    label="El contacto se ha comunicado nuevamente"
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={12}>
                                <TextField
                                  label="Título"
                                  size="small"
                                  fullWidth
                                  onChange={(e) =>
                                    setTitleObservation(e.target.value)
                                  }
                                />
                              </Grid>

                              <Grid item xs={12} width={"100%"}>
                                <textarea
                                  rows={10}
                                  id="textareaid"
                                  style={{
                                    width: "100%",
                                    resize: "none",
                                    borderRadius: "4px",
                                    border: "1px solid rgba(0,0,0,0.25)",
                                    padding: "10px",
                                    boxSizing: "border-box",
                                  }}
                                  value={valCaseTypeForm || ""}
                                  onChange={(e) => {
                                    setValCaseTypeForm(e.target.value);
                                    updateContactData(
                                      "observations",
                                      e.target.value,
                                    );
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    </>
                  )}
                </Grid>

                {/* ================= COLUMNA DERECHA ================= */}
                <Grid
                  item
                  xs={7}
                  sx={{ maxHeight: "550px", overflow: "auto", pl: 2 }}>
                  <Grid item xs={12} sx={{ mb: 2 }}>
                    {sameNifForbidden?.length > 1 && (
                      <Alert
                        severity="warning"
                        sx={{
                          mb: 2,
                          borderRadius: 2,
                          fontSize: "0.9rem",
                          alignItems: "center",
                        }}>
                        Para habilitar las notas en un cliente con contactos
                        asociados, cada contacto debe contar con un documento de
                        identificación único (NIF, DNI, ID, etc.).
                        <br />
                        Para asignar un contacto único, utilice el mismo número
                        de identificación del cliente.
                      </Alert>
                    )}
                    {!showNotes && (
                      <Box textAlign="center">
                        <Button
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: "50%", fontWeight: 700 }}
                          disabled={differentNotes?.length > 0}
                          onClick={() => {
                            setShowNotes(true);
                            setValCaseTypeForm("");
                          }}>
                          {differentNotes?.length > 0 ||
                          sameNifForbidden?.length > 0
                            ? "NOTAS DESHABILITADASS"
                            : "Crear Nota"}
                        </Button>
                      </Box>
                    )}

                    <Typography fontWeight={700} mt={2} textAlign={"center"}>
                      OBSERVACIONES
                    </Typography>

                    {!showNotes && differentNotes?.length > 0 && (
                      <Alert severity="warning" sx={{ mt: 1 }}>
                        El cliente y el contacto tienen notas diferentes.
                        <ContactClientNotesComparisonDialog
                          notas={differentNotes}
                          client={contactData || []}
                          contact={flagClientFounded || []}
                          setFlagToReload={setFlagToReload}
                          flagToReload={flagToReload}
                        />
                      </Alert>
                    )}
                  </Grid>

                  {contactData?.cards?.map((obs, index) => {
                    const statusName =
                      contactStatus?.find((o) => o.id === obs.status)?.nombre ||
                      "Desconocido";

                    return (
                      <ObservationsCards
                        key={index}
                        contact_id={contactId}
                        company={obs?.company_relation?.company_name}
                        observationId={obs?.id}
                        created_by_name={obs?.created_by_relation?.name || "-"}
                        created_by_surname={
                          obs?.created_by_relation?.surname || "-"
                        }
                        created_by_object={obs?.created_by_relation}
                        date={obs?.created_at}
                        title={obs?.title}
                        content={obs?.notas}
                        caseType={obs.types_relation?.case_type}
                        status_name={statusName}
                        setChangeRender={setChangeRender}
                        setShowNotes={setShowNotes}
                      />
                    );
                  })}
                </Grid>
              </Grid>

              <Divider sx={{ width: "100%", mt: "10px" }} />

              {!showNotes && (
                <Grid item xs={12}>
                  <Grid
                    style={{
                      boxShadow: "0px 1px 4px 0px gray",
                      display: "flex",
                      alignItems: "center",
                      marginTop: "10px",
                      width: "100%",
                    }}>
                    <Checkbox
                      checked={
                        marketingToShow == false || marketingToSend == 0
                          ? false
                          : true
                      }
                      onChange={handleChangeCheckbox}
                      color="success"
                    />
                    <span
                      style={{
                        fontWeight: "700",
                        textAlign: "left",
                        color: "#676a6c",
                      }}>
                      Acepto el uso de mi correo electrónico para el envío de
                      comunicaciones con fines informativos y comerciales.
                    </span>
                  </Grid>
                </Grid>
              )}

              <Divider sx={{ mt: 2 }} />

              <Grid item xs={12}>
                <ButtonGroup
                  sx={{ width: "100%", mt: 2 }}
                  fullWidth
                  size="small">
                  {showNotes && (
                    <Button
                      onClick={handleContactsToHistorical}
                      variant="contained"
                      color="success"
                      {...commonButtonProps}>
                      Guardar
                    </Button>
                  )}

                  {showNotes && (
                    <Button
                      onClick={() => {
                        setShowNotes(false);
                        setDateInFilter(contactData?.date_in);
                        setDateInDefault(dayjs(contactData?.date_in));
                        setValCaseTypeForm("");
                        setSelectedCheckboxNotes("");
                      }}
                      color="error"
                      {...commonButtonProps}>
                      Cancelar Nota
                    </Button>
                  )}

                  {!showNotes && !flagToClient && (
                    <Button
                      onClick={handleContactsFormInformation}
                      variant="contained"
                      color="success"
                      startIcon={<Save />}
                      {...commonButtonProps}>
                      GUARDAR
                    </Button>
                  )}

                  {!showNotes && flagToClient && can("clients", "add") && (
                    <Button
                      onClick={handleFormContactsToClient}
                      variant="contained"
                      startIcon={<Save />}
                      disabled={sameNifForbidden?.length > 0 || uniqueRelation}
                      color="success"
                      {...commonButtonProps}>
                      Hacer cliente
                    </Button>
                  )}

                  {!showNotes && (
                    <Button
                      component={Link}
                      to={`/contactos/ver?id=${contactId}`}
                      variant="outlined"
                      color="info"
                      startIcon={<Visibility />}
                      {...commonButtonProps}>
                      Ver
                    </Button>
                  )}

                  {!showNotes && (
                    <Button
                      component={Link}
                      to="/contactos"
                      variant="outlined"
                      startIcon={<TableChart />}
                      color="error">
                      Tabla contactos
                    </Button>
                  )}
                </ButtonGroup>
              </Grid>
            </Box>

            <div style={{ margin: "0px 20px" }}></div>
          </Grid>
        </Fade>
      )}
    </div>
  );
};

export default Editar;
